/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mt_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build a GFM table`)
};

const es_mt_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construye una tabla GFM`)
};

const de_mt_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen Sie eine GFM-Tabelle`)
};

const nl_mt_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bouw een GFM-tabel`)
};

const fr_mt_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer un tableau GFM`)
};

const it_mt_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea una tabella GFM`)
};

const pt_br2_mt_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie uma tabela GFM`)
};

const pt_mt_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construir uma tabela GFM`)
};

const ja_mt_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GFM テーブルを構築`)
};

const zh_mt_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建 GFM 表格`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mt_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mt_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mt_nav_main_desc", locale)
	if (locale === "en") return en_mt_nav_main_desc(inputs)
	if (locale === "es") return es_mt_nav_main_desc(inputs)
	if (locale === "de") return de_mt_nav_main_desc(inputs)
	if (locale === "nl") return nl_mt_nav_main_desc(inputs)
	if (locale === "fr") return fr_mt_nav_main_desc(inputs)
	if (locale === "it") return it_mt_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_mt_nav_main_desc(inputs)
	if (locale === "pt") return pt_mt_nav_main_desc(inputs)
	if (locale === "ja") return ja_mt_nav_main_desc(inputs)
	return zh_mt_nav_main_desc(inputs)
};